import {axiosNodeClient} from "../http";

export const messageSendServiceNode = {
    sendMessage,
    getHistorySend,
    getStatusSMS
}

function getHistorySend(rangeday) {
    return axiosNodeClient.get(`/message/send/history`, {
        params: {
            rangeday: rangeday
        }
    });
}

function getStatusSMS(messageSendId) {
    return axiosNodeClient.get(`/message/send/status-sms`, {
        params: {
            messageSendId: messageSendId
        }
    });
}

function sendMessage(messageSend) {
    return axiosNodeClient.post('/message/send', messageSend);
}
